<template>
  <Dropdown :open.sync="open" position="right" widthClass="dwp-w-48">
    <MoreHorizontalIcon class="dwp-w-4 dwp-h-4 dwp-text-gray-500" @click="open = !open" />
    <template #list>
      <div class="dwp-divide-y dwp-divide-gray-200">
        <div class="dwp-py-2">
          <a
            @click.prevent="edit"
            class="dwp-flex dwp-space-x-2 dwp-group dwp-items-center dwp-truncate dwp-cursor-pointer dwp-select-none dwp-px-4 dwp-py-2 dwp-text-sm dwp-leading-5 dwp-text-gray-700 hover:dwp-bg-gray-100 hover:dwp-text-gray-900 focus:dwp-outline-none focus:dwp-bg-gray-100 focus:dwp-text-gray-900"
            role="menuitem"
          >
            <EditIcon class="dwp-w-4 dwp-h-4 dwp-text-gray-500 dwp-flex-shrink-0" />
            <div>Edit List</div>
          </a>
          <a
            @click.prevent="showCompleted = !showCompleted; open = !open"
            class="dwp-flex dwp-space-x-2 dwp-group dwp-items-center dwp-truncate dwp-cursor-pointer dwp-select-none dwp-px-4 dwp-py-2 dwp-text-sm dwp-leading-5 dwp-text-gray-700 hover:dwp-bg-gray-100 hover:dwp-text-gray-900 focus:dwp-outline-none focus:dwp-bg-gray-100 focus:dwp-text-gray-900"
            role="menuitem"
          >
            <template v-if="!showCompleted">
              <CheckCircleIcon class="dwp-w-4 dwp-h-4 dwp-text-gray-500 dwp-flex-shrink-0" />
              <div>Show Completed</div>
            </template>
            <template v-else>
              <XCircleIcon class="dwp-w-4 dwp-h-4 dwp-text-gray-500 dwp-flex-shrink-0" />
              <div>Hide Completed</div>
            </template>
          </a>
        </div>
        <a
          @click.prevent="trash"
          class="dwp-flex dwp-space-x-2 dwp-group dwp-items-center dwp-truncate dwp-cursor-pointer dwp-select-none dwp-px-4 dwp-py-3 dwp-text-sm dwp-leading-5 dwp-text-gray-700 hover:dwp-bg-gray-100 hover:dwp-text-gray-900 focus:dwp-outline-none focus:dwp-bg-gray-100 focus:dwp-text-gray-900"
          role="menuitem"
        >
          <Trash2Icon class="dwp-w-4 dwp-h-4 dwp-text-gray-500 dwp-flex-shrink-0" />
          <div>Trash List</div>
        </a>
        <a
          @click.prevent="signOut"
          class="dwp-flex dwp-space-x-2 dwp-group dwp-items-center dwp-truncate dwp-cursor-pointer dwp-select-none dwp-px-4 dwp-py-3 dwp-text-sm dwp-leading-5 dwp-text-gray-700 hover:dwp-bg-gray-100 hover:dwp-text-gray-900 focus:dwp-outline-none focus:dwp-bg-gray-100 focus:dwp-text-gray-900"
          role="menuitem"
        >
          <LogOutIcon class="dwp-w-4 dwp-h-4 dwp-text-gray-500 dwp-flex-shrink-0" />
          <div>Sign Out</div>
        </a>
      </div>
    </template>
  </Dropdown>
</template>

<script>
import Dropdown from "@/components/ui/Dropdown.vue";
import {
  MoreHorizontalIcon,
  LogOutIcon,
  Trash2Icon,
  EditIcon,
  CheckCircleIcon,
  XCircleIcon
} from "vue-feather-icons";

import { sync, call, get } from "vuex-pathify";
import currentList from "@/mixins/current-list";

export default {
  mixins: [currentList],
  components: {
    Dropdown,
    MoreHorizontalIcon,
    LogOutIcon,
    Trash2Icon,
    CheckCircleIcon,
    XCircleIcon,
    EditIcon
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    showCompleted: sync("ui/showCompleted"),
    editList: sync("ui/modal@list.edit"),
    loading: sync("ui/loading"),
    user: get("user@user")
  },
  methods: {
    ...call("lists", ["removeList"]),
    ...call("user", ["signOut"]),

    edit() {
      this.editList = {
        open: true,
        list: this.currentList
      };
    },

    async trash() {
      let r = confirm(
        "Are you sure you want to move this list and it's tasks to the trash?"
      );
      if (r) {
        this.loading = true;
        this.open = false;
        await this.removeList(this.currentList);
        this.loading = false;
        this.$store.commit("lists/resetCurrent");
      }
    }
  }
};
</script>